import React, { useState, useEffect, useRef } from "react";
import MyInput from "./Input";
import { CameraOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Modal, Avatar } from "antd";
import { RcFile, UploadProps } from "antd/es/upload";
import { UploadFile } from "antd/es/upload/interface";
import "../components/style/uploadimg.css";
import Resizer from "react-image-file-resizer";
import DefaultProfile from "../../src/assets/Profile_Default.png";
import { COLORS } from "../constants/Colors";
import { FormattedMessage, useIntl } from "react-intl";

const RegisterForm = ({
  setProfilePic,
  setName,
  name,
  setPhone,
  phone,
  setEmail,
  email,
  setPassword,
  password,
  setPasswordCf,
  passwordCf,
  setAcceptPolicy,
  acceptPolicy,
  setErrorValidate,
  errorValidate,
  setErrorValidatePassword,
  errorValidatePassword,
  setIsCheck,
  isCheck,
  setErrorValidatePhone,
  errorValidatePhone,
  setErrorDigitPassword,
  errorDigitPassword,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [isJpgOrPng, setIsJpgOrPng] = useState(true);
  const imageRef = useRef();
  const [imageFileDefault, setImageFileDefault] = useState("");
  const intl = useIntl();

  const beforeUpload = (file) => {
    const checkIsJpgOrPng =
      file.type === "image/jpeg" || file.type === "image/png";
    if (!checkIsJpgOrPng) {
      setIsJpgOrPng(false);
      message.error("You can only upload JPG/PNG file!");
      setPreviewImage("");
      setPreviewTitle("");
    } else {
      setIsJpgOrPng(true);
    }
    return isJpgOrPng;
  };

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const inputName = (e) => {
    setName(e.target.value);
    setIsCheck((prev) => !prev);
  };

  const inputPhone = (e) => {
    const numberRegex = new RegExp(/^[0-9]{0,10}$/);
    const isValidNumber = numberRegex.test(e.target.value);
    if (isValidNumber) {
      setPhone(e.target.value);
      setIsCheck((prev) => !prev);
    }
  };

  const inputEmail = (e) => {
    setEmail(e.target.value);
    setIsCheck((prev) => !prev);
    const emailRegex = new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/);
    const isValidEmail = emailRegex.test(email);
    if (isValidEmail || e.target.value === "") {
      setErrorValidate("");
    } else {
      setErrorValidate(intl.formatMessage({ id: 'validateEmailSignup', defaultMessage: 'Email Invalid' }));
    }
  };

  const inputPassword = (e) => {
    setPassword(e.target.value);
    setIsCheck((prev) => !prev);
    if (password !== passwordCf) {
      setErrorValidatePassword(intl.formatMessage({ id: 'validateConfirmPasswordSignup', defaultMessage: 'Password not match!' }));
    } else {
      setErrorValidatePassword("");
    }
  };

  const inputPasswordCf = (e) => {
    setPasswordCf(e.target.value);
    setIsCheck((prev) => !prev);
    if (password !== passwordCf) {
      setErrorValidatePassword(intl.formatMessage({ id: 'validateConfirmPasswordSignup', defaultMessage: 'Password not match!' }));
    } else {
      setErrorValidatePassword("");
    }
  };

  const checkMatchPassword = () => {
    if (passwordCf !== "") {
      if (password !== passwordCf) {
        return <div style={{ color: "red",fontSize: "13px" }}><FormattedMessage id='validateConfirmPasswordSignup' defaultMessage='Password not match!' /></div>;
      } else {
        return null;
      }
    }
  };

  useEffect(() => {
    setImageFileDefault(DefaultProfile);
  }, []);

  const showOpenFileDialog = (e) => {
    imageRef.current.click();
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        720,
        720,
        "JPEG",
        70,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    for (var i = 0; i < bstr.length; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleChangePicture = async (event) => {
    event.preventDefault();
    let reader = new FileReader();
    const file = event.target.files[0];

    if (file) {
      if (file.name.match(/\.(jpg|jpeg|png|JPG|PNG|JPEG)$/)) {
        const image = await resizeFile(file);
        reader.onloadend = () => {
          const image = reader.result;
          setPreviewImage(image);
        };
        reader.readAsDataURL(file);

        const fileChange = dataURLtoFile(image, file.name);
        setProfilePic(fileChange);
      }
    }
  };

  const checkDigitPhone = (phone) => {
    if(phone != ""){
    if (phone.length < 10) {
      setErrorValidatePhone(intl.formatMessage({ id: 'validatePhoneSignup', defaultMessage: 'Please complete your 10-digit phone number.' }));
      return true;
    } else {
      setErrorValidatePhone("");
      return false;
    }
  }
  };

  const checkDigitpassword = (password) => {
    if(password != ""){
    if (password.length < 6) {
      setErrorDigitPassword(intl.formatMessage({ id: 'validatePasswordSignup', defaultMessage: 'Password must be 6 characters long.' }));
      return true;
    } else {
      setErrorDigitPassword("");
      return false;
    }
  }
  };

  return (
    <div>
      <div style={{ position: "relative", display: "inline-block" }}>
        <Avatar
          size={100}
          sx={{
            width: 160,
            height: 160,
            "& img": {
              borderRadius: "50%",
            },
          }}
          alt="Profile Avatar"
          src={previewImage ? previewImage : imageFileDefault}
        />
        <div
          style={{
            position: "absolute",
            bottom: 5,
            right: 1,
            width: "30px",
            height: "30px",
            backgroundColor: `${COLORS.Primary}`,
            borderRadius: "70%",
            borderStyle: "solid",
            borderColor: "#fff",
            borderWidth: 2,
            padding: 2,
            cursor: "pointer",
          }}
          onClick={showOpenFileDialog}
        >
          <CameraOutlined
            style={{
              color: "#fff",
              marginTop: "4px",
              fontSize: "14px",
            }}
          />
        </div>
      </div>
      <input
        ref={imageRef}
        type="file"
        style={{ display: "none" }}
        accept=".jpg, .png, .JPG, .PNG"
        onChange={handleChangePicture}
      />
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
      <div style={{ margin: "11%" }}></div>
      <MyInput
        label={<FormattedMessage id='labelName' defaultMessage='Name' />}
        placeholder={intl.formatMessage({ id: 'labelName', defaultMessage: 'Name' })}
        isRequired
        className="pb-4"
        value={name}
        onChange={inputName}
      />
      <MyInput
        label={<FormattedMessage id='labelPhone' defaultMessage='Phone Number' />}
        placeholder={intl.formatMessage({ id: 'labelPhone', defaultMessage: 'Phone Number' })}
        isRequired
        className="pb-4"
        value={phone}
        isError={checkDigitPhone(phone)}
        errorMsg={errorValidatePhone}
        onChange={inputPhone}
      />
      <MyInput
        label={<FormattedMessage id='labelEmail' defaultMessage='Email' />}
        placeholder={intl.formatMessage({ id: 'labelEmail', defaultMessage: 'Email' })}
        className="pb-4"
        value={email}
        isError={errorValidate !== "" ? true : false}
        errorMsg={errorValidate}
        onChange={inputEmail}
      />

      <MyInput
        label={<FormattedMessage id='labelPassword' defaultMessage='Password' />}
        type="password"
        isPassword
        placeholder={intl.formatMessage({ id: 'labelPassword', defaultMessage: 'Password' })}
        isRequired
        className="pb-4"
        value={password}
        isError={checkDigitpassword(password)}
        errorMsg={errorDigitPassword}
        onChange={inputPassword}
      />
      <MyInput
        label={<FormattedMessage id='labeConfirmPassword' defaultMessage='Confirm Password' />}
        type="password"
        isPassword
        placeholder={intl.formatMessage({ id: 'labeConfirmPassword', defaultMessage: 'Confirm Password' })}
        isRequired
        value={passwordCf}
        onChange={inputPasswordCf}
      />
      {checkMatchPassword()}
    </div>
  );
};

export default RegisterForm;
